"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "bianchi": {
    "affeeb15": [{
      "hkey": "eb54db47",
      "slug": "paragolio-serradipiro",
      "name": "Paragolio-Serradipiro",
      "primary": true,
      "skipSearch": false
    }],
    "paragolio": [{
      "hkey": "eb54db47",
      "slug": "paragolio-serradipiro",
      "name": "Paragolio-Serradipiro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "bianchi"
    }],
    "251c3049": [{
      "hkey": "eb54db47",
      "slug": "paragolio-serradipiro",
      "name": "Paragolio-Serradipiro",
      "primary": true,
      "skipSearch": false
    }],
    "serradipiro": [{
      "hkey": "eb54db47",
      "slug": "paragolio-serradipiro",
      "name": "Paragolio-Serradipiro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;